import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOMeta from '@/components/feature/SEOMeta';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import { movies, bannerSlides, featuredMovieIds, hotMovieIds, newMovieIds } from '@/mocks/movies';

export default function Home() {
  const featuredMovies = movies.filter((m) => featuredMovieIds.includes(m.id));
  const hotMovies = movies.filter((m) => hotMovieIds.includes(m.id));
  const newMovies = movies.filter((m) => newMovieIds.includes(m.id));

  return (
    <>
      <ScrollToTop />
      <SEOMeta
        title="奇优影院 | 免费在线观看电影电视剧全集高清 - 奇优影院不收费免费版"
        description="奇优影院是免费在线观看平台，提供奇优影院免费版、不收费的影视资源。最新电影电视剧大全高清播放，无需付费即可畅享海量内容。奇优影院免费观看，高清不缓冲，尽在奇优影院在线看。"
        keywords="奇优影院,奇优影院免费,奇优影院免费观看,奇优影院在线看,奇优影院不收费,奇优影院免费版,免费电影在线观看,免费电视剧全集,高清不缓冲"
        canonicalUrl="https://www.qiyoucinema.com/"
        ogType="website"
      />
      <SchemaOrg type="Organization" data={{
        name: '奇优影院',
        url: 'https://www.qiyoucinema.com/',
        description: '奇优影院是免费在线观看平台，提供最新最全的电影、电视剧、综艺、动漫和纪录片资源。',
        sameAs: ['https://weibo.com/qiyoucinema'],
      }} />
      <SchemaOrg type="WebSite" data={{
        name: '奇优影院',
        url: 'https://www.qiyoucinema.com/',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://www.qiyoucinema.com/category/all?search={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection movies={movies} slides={bannerSlides} />

          <FeaturedSection
            title="精选推荐"
            movies={featuredMovies}
            viewAllLink="/category/all"
          />

          <CategorySection />

          <FeaturedSection
            title="热门影片"
            movies={hotMovies}
            viewAllLink="/category/all"
          />

          <FeaturedSection
            title="最新上线"
            movies={newMovies}
            viewAllLink="/category/all"
          />

          <ArticleSection />

          <FAQSection />
        </main>

        <Footer />
      </div>
    </>
  );
}